import { Routes, Route } from "react-router-dom";
import { JobsProvider } from "~/providers/jobs";
import { Space } from "~/lib/types";
import { OverviewTab } from "~/components/asset-overview-tab";
import { PageLayout } from "~/routes";
import { AssetPoliciesTab } from "~/pages/inventory/asset/asset-policies-tab";
import { AssetSoftwareTab } from "~/pages/inventory/components/AssetSoftware";
import { AssetDataQueries } from "~/pages/inventory/data-queries";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import ProjectsEntryPage from "~/entry-pages/space/cicd/projects/ProjectsEntryPage";
import JobsEntryPage from "~/entry-pages/space/cicd/jobs/JobsEntryPage";
import JobEntryPage from "~/entry-pages/space/cicd/jobs/[jobId]/JobEntryPage";
import { AssetFindingsTab } from "~/pages/inventory/asset/AssetFindingsTab";
import { LegacyRedirect } from "~/routes/LegacyRouteRedirect";

interface CicdRoutesProps {
  space: Space;
}

export const CicdRoutes = ({ space }: CicdRoutesProps) => {
  const { isFeatureEnabled } = useFeatureFlags();

  return (
    <Routes>
      <Route index element={<ProjectsEntryPage {...{ space }} />} />

      <Route
        path="jobs/*"
        element={
          <JobsProvider>
            <Routes>
              <Route element={<PageLayout />}>
                <Route index element={<JobsEntryPage {...{ space }} />} />
              </Route>

              <Route path="/:id" element={<JobEntryPage {...{ space }} />}>
                <Route index element={<OverviewTab />} />
                <Route path="overview" element={<OverviewTab />} />
                <Route path="findings" element={<AssetFindingsTab />} />
                <Route path="policies" element={<AssetPoliciesTab />} />
                <Route path="data-queries" element={<AssetDataQueries />} />
                <Route path="software" element={<AssetSoftwareTab />} />

                {/* Redirect legacy list routes to findings with type filter for backwards compatibility */}
                <Route
                  path="/:id/advisories"
                  element={<LegacyRedirect from="advisories" type="ADVISORY" />}
                />
                <Route
                  path="/:id/vulnerabilities"
                  element={<LegacyRedirect from="vulnerabilities" type="CVE" />}
                />
                <Route
                  path="/:id/checks"
                  element={<LegacyRedirect from="checks" type="CHECK" />}
                />
              </Route>
            </Routes>
          </JobsProvider>
        }
      />
    </Routes>
  );
};
